import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter as Router } from "react-router-dom";
import ApolloClient from "apollo-boost";
import {
  graphqlApi
  // , wsApi 
} from './Config';
import { ApolloProvider } from "react-apollo";
import { InMemoryCache } from 'apollo-cache-inmemory';
import { defaults, resolvers, typeDefs } from './resolvers';
// import { split } from 'apollo-link';
// import { WebSocketLink } from 'apollo-link-ws';
// import { getMainDefinition } from 'apollo-utilities';


const cache = new InMemoryCache({
  dataIdFromObject: o => `${o.__typename}_${o._id || '0'}`
});

// const wsLink = new WebSocketLink({
//   uri: wsApi,
//   options: {
//     reconnect: true,
//     connectionParams: {
//       authToken: window.localStorage.token,
//     },
//   }
// });

// const link = split(
//   ({ query }) => {
//     const { kind, operation } = getMainDefinition(query);
//     return kind === 'OperationDefinition' && operation === 'subscription';
//   },
//   wsLink
// );

const client = new ApolloClient({
  // link,
  uri: graphqlApi,
  fetchOptions: {
    credentials: 'include'
  },
  request: async (operation) => {
    const token = await localStorage.getItem('token');
    operation.setContext({
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  },
  cache,
  clientState: {
    defaults,
    resolvers,
    typeDefs
  }
});

const AppWithApollo = () => (
  <ApolloProvider client={client}>
    <Router><App /></Router>
  </ApolloProvider>
)

ReactDOM.render(<AppWithApollo />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js